/**
 * 
 * @param {function} setSelectedVariants // state Setter
 * @returns 
 */
export const handleWoocommerceVariantUpdateForSwatchly = (setSelectedVariants) => {
    const parentEl = document.querySelector('table.variations');
    if (!parentEl) return;
    const labels = parentEl.querySelectorAll('.label label');
    const variations = {}
    labels?.forEach(label => {
        variations[`attribute_${label.getAttribute('for')}`] = "";
    });
    setSelectedVariants(variations);

    parentEl.querySelectorAll('tr')?.forEach(row => {
        const attr = row?.querySelector('.label label')?.getAttribute('for');
        row.querySelectorAll('.swatchly-swatch')?.forEach(el => {
            el.addEventListener('click', () => {
                variations[`attribute_${attr}`] = el.getAttribute('data-attr_value');
                setSelectedVariants((oldData) => {
                    return { ...oldData, [`attribute_${attr}`]: el.getAttribute('data-attr_value') }
                });
            })
        })
    });
}


export const handleWoocommerceVariantUpdateDefault = (setSelectedVariants) => {
    document.querySelectorAll(".variations_form .variations select")?.forEach((select) => {
        const variations = {};
        variations[select.name] = select.value;
        select.addEventListener("change", function (e) {
            setSelectedVariants((oldData) => ({
                ...oldData,
                [select.name]: select.value,
            }));
        });
        setSelectedVariants(variations);
    })

}